import type { TopPartRow } from './types'

/** Символ валюты квоты — цены поставщиков живут в валюте, а не в рублях. */
const CURRENCY_SIGN: Record<string, string> = { USD: '$', EUR: '€', CNY: '¥', RUB: '₽' }

/**
 * Разброс закупочных цен по партномеру (19.09.2026): «мин — макс» в той
 * валюте, в которой квотировали. Прежний столбец «Цена, %» показывал
 * изменение к прошлому периоду и заказчику был непонятен.
 */
function PriceRangeCell({ range }: { range: TopPartRow['priceRange'] }) {
  if (!range) return <span className="text-gray-400">—</span>
  const sign = CURRENCY_SIGN[range.currency] ?? range.currency
  const fmt = (v: number) => v.toLocaleString('ru-RU', { maximumFractionDigits: 2 })
  return (
    <span className="tabular-nums text-gray-700">
      {range.min === range.max
        ? `${sign} ${fmt(range.min)}`
        : `${sign} ${fmt(range.min)} — ${fmt(range.max)}`}
    </span>
  )
}

export function TopPartsTable({
  topParts,
  onRowClick,
}: {
  topParts: TopPartRow[]
  onRowClick?: (target: { partNumber: string; brand: string | null }) => void
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4">
      <div className="mb-1 text-sm text-gray-500">Топ парт-номеров</div>
      <div className="text-[11px] text-gray-400 mb-3">Клик по строке → история цены</div>

      {topParts.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Нет данных за период</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-xs text-gray-500">
              <th className="text-left font-normal pb-2">Парт-номер</th>
              <th className="text-left font-normal pb-2">Бренд</th>
              <th className="text-right font-normal pb-2">Запросов</th>
              <th className="text-right font-normal pb-2">Клиентов</th>
              <th className="text-right font-normal pb-2">Цена: мин — макс</th>
            </tr>
          </thead>
          <tbody>
            {topParts.map((p) => (
              <tr
                key={`${p.partNumber}-${p.brand ?? ''}`}
                onClick={() => onRowClick?.({ partNumber: p.partNumber, brand: p.brand })}
                className={`border-t border-gray-100 ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
              >
                <td className="py-2 font-mono text-xs text-gray-900">{p.partNumber}</td>
                <td className="py-2 text-gray-600">{p.brand ?? '—'}</td>
                <td className="py-2 text-right tabular-nums">{p.requestsCount}</td>
                <td className="py-2 text-right tabular-nums text-gray-600">{p.clientsCount}</td>
                <td className="py-2 text-right">
                  <PriceRangeCell range={p.priceRange} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
